// define a mixin object
export default {
    props: ['modelValue'],
    emits: ["update:modelValue", "input", "change"],
    data() {
        return {
            vModelMixinDebounceHandler: null,
            vModelMixinDebounceTimeout: 1000,
        }
    },
    computed: {
        currentValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.fireEvents(value);
            }
        },
        currentDebounceValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                if (this.vModelMixinDebounceHandler) {
                    clearTimeout(this.vModelMixinDebounceHandler);
                }
                this.vModelMixinDebounceHandler = setTimeout(() => {
                    this.fireEvents(value);
                }, this.vModelMixinDebounceTimeout);
            }
        }
    },
    methods: {
        fireEvents(value) {
            this.$emit("update:modelValue", value);
            this.$emit('input', value);
            this.$emit('change', value);
        }
    }
}
